import React from "react";
import { User } from "../types";

export const UsersContext = React.createContext<Array<User>>([])